import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ToggleItemTextVisibilityButtonComponent } from "@components/toggle-item-text-visibility-button/toggle-item-text-visibility-button.component";
import { ToggleLockButtonComponent } from "@components/toggle-lock-button/toggle-lock-button.component";
import { ToggleVisibilityButtonComponent } from "@components/toggle-visibility-button/toggle-visibility-button.component";
import { FloorplanState } from "@domain/project/floorplan/floorplan-state";
import { ButtonComponent } from "@odx/angular/components/button";
import { IconComponent } from "@odx/angular/components/icon";
import { FloorplanZonesService } from "@project/floorplan-zones.service";
import { FloorplanMenuItemButtonsComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-item-buttons/floorplan-menu-item-buttons.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-it-room-menu",
  imports: [
    ButtonComponent,
    FloorplanMenuItemButtonsComponent,
    IconComponent,
    ToggleLockButtonComponent,
    ToggleVisibilityButtonComponent,
    UiKitModule,
    ToggleItemTextVisibilityButtonComponent,
  ],
  templateUrl: "./it-room-menu.component.html",
  styleUrl: "./it-room-menu.component.scss",
})
export class ItRoomMenuComponent {
  private floorplanService = inject(FloorplanService);
  private floorplanZonesService = inject(FloorplanZonesService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplanState: FloorplanState;
  protected readonly tooltipText: string = $localize`:@@floorplan.monitoring.button.addItRoom:Add IT room`;

  constructor() {
    this.floorplanState = this.floorplanService.selectedFloorplan.floorplanState;
  }

  protected addItRoom() {
    this.floorplanZonesService.addItRoom();
  }

  protected dragItRoom() {
    this.dragDropService.setDragged({ type: DraggedItemType.IT_ROOM });
  }

  protected updateItRoomsItemTextVisibility(visible: boolean) {
    this.floorplanState.updateItRoomsItemTextVisibility(visible);
  }
}
